export default {

    data: () => {
        return {
            onesignal_is_subscribed: false,
            onesignal_key: 0
        }
    },


    computed: {

        onesignal_subscribe_button_text() {

            let
                is = this.onesignal_is_subscribed
            ;

            if ( is ) {

                return this.__('Perfect! You can now receive notifications')

            }

            return this.__('Allow browser notifications');

        },

    },


    methods: {

        force_update_onesignal() {

            this.onesignal_key += 1;

        },

        init_one_signal() {

            if (
                window.OneSignal
                && window.OneSignal.initialized
            ) {

                return;

            }


            window.OneSignal = window.OneSignal || [];

            window.OneSignal.push(() => {

                window.OneSignal.init({
                    appId: this.$page.props.one_signal.app_id,
                    safari_web_id: this.$page.props.one_signal.safari_web_id,
                }).then(() => {

                    OneSignal.setExternalUserId( this.$page.props.one_signal.user_id, this.$page.props.one_signal.user_id_hash );

                    this.onesignal_update_is_subscribed();

                });

            });

        },

        async onesignal_update_is_subscribed() {                                   let debug_id = Debug.init_method('onesignal_update_is_subscribed',true);
                                                                                    Debug.log(debug_id,63,true);
            if (
                ! window.OneSignal
                || ! window.OneSignal.initialized
            ) {                                                                     Debug.log(debug_id,70,true);

                this.onesignal_is_subscribed = false;

                return;

            }


            window.OneSignal.isPushNotificationsEnabled((isEnabled) => {           Debug.log(debug_id,77,isEnabled);

                this.onesignal_is_subscribed = isEnabled;

                this.force_update_onesignal();

            });

        },

        async onesignal_handle_click() {                                                  let debug_id = Debug.init_method('onesignal_handle_click',true);

            if ( ! this.onesignal_is_subscribed ) {                                 Debug.log(debug_id,87,true);

                await window.OneSignal.showNativePrompt();

                window.OneSignal.setSubscription(true);

            }
            else {                                                                  Debug.log(debug_id,92,true);

                window.OneSignal.setSubscription(false);

                this.onesignal_is_subscribed = false;

            }


            this.onesignal_update_is_subscribed();

        }

    }

}
